<template>
    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable width="auto">
        <v-card>
          <v-toolbar flat dark color="primary" class="max-height">
            <v-toolbar-title> Actualizar datos del modulo </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false"> <v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>

          <v-card-text> 
            <v-row class="mt-2">
                <v-col>
                    <FechaMod ref="refFechaMod1" label="Fecha inicio:" v-on:select="input.fecha_inicio = $event" :valor="input.fecha_inicio"/>
                </v-col>
                <v-col>
                    <FechaMod ref="refFechaMod2" label="Fecha fin:" v-on:select="input.fecha_fin = $event" :valor="input.fecha_fin"/>
                </v-col>
            </v-row>
            <v-progress-linear v-if="loading" indeterminate height="1" />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn square outlined :loading="loading" color="green" @click="guardar()"> <v-icon> mdi-check </v-icon> actualizar </v-btn>
            <v-btn square outlined :loading="loading" color="error" @click="dialog = false"> <v-icon> mdi-close</v-icon> cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </template>

  <script>
  import FechaMod from './edit_mod_fecha.vue';
  import axios from '@/xaxios';

  export default {
    components: { FechaMod },
    props: [],
    emits:['onsuccess'],
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        dialog: false,
        loading: false,
        input: {
            programa_modulo_id: null,
            modulo_id: null,
            docente_id: null,
            numero: null,
            fecha_inicio: null,
            fecha_fin: null,
            estado: null,
        }
      };
    },
  
    methods: { 
        openDialog(item){
            window.console.log('>>>>:', item);
            this.input.programa_modulo_id = item.id;
            this.input.modulo_id = item.idmodulo;
            this.input.docente_id = item.iddocente;
            this.input.numero = item.numero;
            this.input.fecha_inicio = item.inicio;
            this.input.fecha_fin = item.fin;
            this.input.estado = item.estado;
            this.dialog = true; 
            const vue = this;
            setTimeout(() => {
              vue.$refs.refFechaMod1.set(item.inicio);
              vue.$refs.refFechaMod2.set(item.fin);
            }, 200);
        },
        parseFecha(d){
          if(!d) return d;
          const fs = (d+'').split('-'); 
          return `${fs[2]}/${fs[1]}/${fs[0]}`
        },
        async guardar(){
          const data = {
            id: this.input.programa_modulo_id,
            fecha_inicio: this.parseFecha(this.input.fecha_inicio),
            fecha_fin: this.parseFecha(this.input.fecha_fin)
          }

          this.loading = true;
          const url = this.api_rest+'/api/v1/esam/programa/modulo/date'
          const res = await axios.put(url, data).then(data=>data).catch(e=>e)
          if(res && res.response){
            this.$root.$notify.show(res.response.data.errors, {color:'red',x: 'right',});
          }else if( res && res.data){
            const t = res.data.data;
            this.$emit('onsuccess', data);
            this.$root.$notify.show(t, {color:'success',x: 'right',});
            this.dialog = false;
          }
          this.loading = false;
        }
    },
  };
  </script> 